<div class="component-container h-full flex flex-col">
  <div class="request-details flex flex-col flex-1">
    <div class="heading text-type-2 mb-[40px]">
      {{ data?.id || data?.uuid || bidItemDetails?.id ? (bidItemDetails?.item || data?.item || '') : 'Create bid item' }}
    </div>
    <div class="header-section flex justify-start items-start gap-[32px]">
      <ng-container *ngFor="let header of headersList | slice:0:2">
        <div
          (click)="selectHeader(header)"
          [class.selected]="selectedTabId === header.id"
          class="header text-type-3 cursor-pointer text-[#60698B]"
        >
          {{ header.label }}
        </div>
      </ng-container>
      <div
        *ngIf="(headersList | slice:2).length > 0"
        [class.selected]="selectedTabLabel"
        [matMenuTriggerFor]="menu"
        class="header text-type-3 cursor-pointer text-[#60698B] flex justify-center items-center"
      >
        {{ selectedTabLabel || 'More' }}
        <span>
          <mat-icon [svgIcon]="'chevron-down'" class="chevron-icon" />
        </span>
      </div>
      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let header of headersList | slice:2">
          <button (click)="selectMenu(header)" class="header text-type-3 cursor-pointer text-[#60698B]" mat-menu-item>
            {{ header.label }}
          </button>
        </ng-container>
      </mat-menu>
    </div>
    <div class="content-section flex-1 flex flex-col min-h-0" [ngSwitch]="selectedTabId">
        <ng-container *ngSwitchCase="0">
          <app-create-or-edit-bid-item [data]="bidItemDetails" class="tab-content" />
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <div class="tab-content">Headings content</div>
        </ng-container>
        <ng-container *ngSwitchCase="2">
          <app-bid-items-fields [data]="bidItemDetails" [projectId]="data?.projectId" class="tab-content"/>
        </ng-container>
<ng-container *ngSwitchCase="5">
          <app-bid-items-site-quantities [data]="bidItemDetails" [projectId]="data?.projectId" class="tab-content" />
        </ng-container>
        <ng-container *ngSwitchCase="6">
          <app-bid-items-shapes [data]="bidItemDetails" [projectId]="data?.projectId" class="tab-content" />
        </ng-container>
    </div>
  </div>
</div>
